// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Zj","zenCrossSiteLabel":"_j","vrsnlCrossSiteLabel":"ak"};